export default {
  /**
   * @param {array} errors
   * @param {object} fieldsIdMapping
   * @return {object}
   */
  mapErrorFields(errors, fieldsIdMapping = {}) {
    return errors.reduce((mappedErrors, error) => {
      const errorKey = fieldsIdMapping.hasOwnProperty(error.field) ? fieldsIdMapping[error.field] : error.field;
      mappedErrors[errorKey] = error.message;
      return mappedErrors;
    }, {});
  }
};
